import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { EClosePeriodAction } from "../ClosePeriod/ClosePeriod";

interface IClosePeriodActionsProps {
    handleChangePage: (page: number) => void;
    page: number;
    handleClosePeriod: () => void;
    closePeriodAction: EClosePeriodAction | undefined;
    unpaidBeneficiariesCount: number;
    checkboxes: { label: string; checked: boolean; show: boolean }[];
    isLoadingRightButton: boolean;
    close: () => void;
}
export const ClosePeriodActions = ({
    handleChangePage,
    page,
    handleClosePeriod,
    closePeriodAction,
    unpaidBeneficiariesCount,
    checkboxes,
    isLoadingRightButton,
    close,
}: IClosePeriodActionsProps) => {
    return (
        <div className="close-period-modal-content-actions">
            <ActionLeftButton page={page} handleChangePage={handleChangePage} close={close} />

            <ActionRightButton
                page={page}
                handleChangePage={handleChangePage}
                handleClosePeriod={handleClosePeriod}
                isLoadingRightButton={isLoadingRightButton}
                unpaidBeneficiariesCount={unpaidBeneficiariesCount}
                checkboxes={checkboxes}
                closePeriodAction={closePeriodAction}
            />
        </div>
    );
};

const ActionLeftButton = ({
    page,
    handleChangePage,
    close,
}: {
    page: number;
    handleChangePage: (page: number) => void;
    close: () => void;
}) => {
    const [t] = useTranslation();
    const handleButtonLeftAction = () => {
        if (page == 0) close();
        if (page == 1) handleChangePage(0);
    };

    const getButtonLeftLabel = () => {
        if (page == 0) return t("Management.ClosePeriodModal.Later");
        if (page == 1) return t("ConnectTitle.PreviousStep");
    };

    return (
        <StyledButton buttonType="secondary" fullWidth onClick={handleButtonLeftAction}>
            {getButtonLeftLabel()}
        </StyledButton>
    );
};

const ActionRightButton = ({
    page,
    handleChangePage,
    handleClosePeriod,
    isLoadingRightButton,
    unpaidBeneficiariesCount,
    checkboxes,
    closePeriodAction,
}: {
    page: number;
    handleChangePage: (page: number) => void;
    handleClosePeriod: () => void;
    isLoadingRightButton: boolean;
    unpaidBeneficiariesCount: number;
    checkboxes: { label: string; checked: boolean; show: boolean }[];
    closePeriodAction: EClosePeriodAction | undefined;
}) => {
    const [t] = useTranslation();

    const handleButtonRightAction = () => {
        if (page == 0 && unpaidBeneficiariesCount > 0) {
            handleChangePage(1);
        } else {
            handleClosePeriod();
        }
    };

    const getButtonRightLabel = () => {
        if (unpaidBeneficiariesCount > 0 && page == 0) return t("Management.ClosePeriodModal.Next");
        else return t("Management.ClosePeriodModal.ClosePeriod");
    };

    const handleDisableRightButton = () => {
        const hasMissingChecks = !checkboxes.every((checkbox) => checkbox.checked);

        const isUnpaidBeneficiaries = unpaidBeneficiariesCount > 0 && page == 1;
        const isPendingForChoice = closePeriodAction == undefined;

        return hasMissingChecks || (isUnpaidBeneficiaries && isPendingForChoice);
    };
    return (
        <StyledButton
            buttonType="primary"
            fullWidth
            onClick={handleButtonRightAction}
            disabled={handleDisableRightButton()}
            loading={isLoadingRightButton}
        >
            {getButtonRightLabel()}
        </StyledButton>
    );
};
